import * as React from 'react'

import { Box, Button, Table } from '@factorialco/deprecated-design-system'
import { TimesheetReviewsStatsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import PeriodStatus from 'modules/attendance/components/ClockIn/Shifts/DailyShifts/DailyTable/PeriodStatus'
import { usePeriodApproval } from 'modules/attendance/hooks/usePeriodApproval'
import { useAttendancePolicies } from 'modules/attendance/lib/attendancePolicies'
import { PeriodState } from 'modules/attendance/lib/types'

interface Props {
  reviewsStats: TimesheetReviewsStatsFragment | null
  employeeId: string
}

const Head = ({ reviewsStats, employeeId }: Props) => {
  const isClockInSection = window.location.pathname.includes('attendance/clock-in')
  const state = reviewsStats?.state
  const { data } = useAttendancePolicies()
  const canApprovePeriod = !!data?._policies?.companyApproveAttendance?.can
  const showApproveButton =
    !isClockInSection && canApprovePeriod && state !== PeriodState.in_progress

  const label =
    state === PeriodState.approved
      ? i18n.t('clock_in.header.actions.disapprove')
      : i18n.t('clock_in.header.actions.approve')

  const { approvePeriod, disapprovePeriod, loading } = usePeriodApproval({ employeeId })

  const handleConfirmPeriod = async () => {
    state === 'approved' ? await disapprovePeriod() : await approvePeriod()
  }

  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell colSpan={3} background="grey000White">
          <PeriodStatus reviewsStats={reviewsStats} />
        </Table.HeadCell>
        <Table.HeadCell background="grey000White">
          <Box flexDirection="row" justifyContent="flexEnd" width="full">
            {showApproveButton && (
              <Button onClick={handleConfirmPeriod} type="primary" disabled={loading}>
                {label}
              </Button>
            )}
          </Box>
        </Table.HeadCell>
      </Table.Row>
      <Table.Row>
        <Table.HeadCell background="grey000White">
          {i18n.t('clock_in.bulk_action.days')}
        </Table.HeadCell>
        <Table.HeadCell background="grey000White">
          {i18n.t('clock_in.bulk_action.worked_shifts')}
        </Table.HeadCell>
        <Table.HeadCell background="grey000White" colSpan={2} />
      </Table.Row>
    </Table.Head>
  )
}

export default Head
